import { PromptType } from 'services/store/ai/types';
import getAdvancedPromptFormData from './getAdvancedPromptFormData';
import getTextPromptFormData from './getTextPromptFormData';
import { AIGeneratorPromptData } from './types';

const getPromptFormData = (prompt: AIGeneratorPromptData): FormData => {
  if (prompt.promptType === PromptType.TextToMusic) {
    return getTextPromptFormData(prompt);
  }
  if (prompt.promptType === PromptType.AdvancedFormula) {
    return getAdvancedPromptFormData(prompt);
  }
  throw new Error('unknown prompt type');
};

export default getPromptFormData;
